<template>
  <div class="vip-panel" v-if="isVip === true">
    <div class="vip-state" v-if="vipState == 'travelling'">
      <van-button type="primary" block>我会提前到</van-button>
      <van-button type="primary" block>我会迟到</van-button>
    </div>
    <div class="vip-state" v-if="vipState == 'unTravel'">
      <van-button type="primary" block @click="goTravel">我出发了</van-button>
    </div>
  <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" :loading="loading" @confirm="onConfirm"
  @cancel="onCancel"/>
  </van-popup>

  </div>
</template>
<style lang="scss" scoped>
  .vip-state{
    margin: 0 1rem;
  }
</style>
<script>
  export default {
    props: {
      vipState: {
        type: String,
        default: ""
      },
      isVip: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        columns: [],
        loading: true,
        showPicker:false,
      };
    },
    created() {
    },
    methods:{
      goTravel()
      {
        this.showPicker = true;
        this.loading = false;
        this.columns = ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'];
      },
      onConfirm()
      {
        console.log('onConfirm');
      },
      onCancel()
      {
        this.showPicker = false;
      },
    },
  }
</script>
